export const PHANTOM_DEEPLINK_BASE_URL = 'https://phantom.app/ul/v1';

export const PHANTOM_SESSION_STORAGE_KEY = 'phantom_session';

export const PHANTOM_PENDING_REQUEST_STORAGE_KEY = 'phantom_pending_request';

export const PHANTOM_REDIRECT_TIMEOUT_MS = 300000; // 5 minutes
